export default function() {
	const res = this.checkParams()
	if (!res) {
		return
	}
	const { order, injured, setting } = this
	const committeeSurvey = (injured && injured.homeCommitteeSurvey) || {}

	let arr = [
		{
			label: '走访单位属性',
			value: setting.committeeTypeMap[committeeSurvey.committeeType],
		},
		{
			label: '走访单位名称',
			value: committeeSurvey.committeeName,
		},
		{
			label: '被询问人姓名',
			value: committeeSurvey.intervieweeName,
		},
		{
			label: '被询问人职务',
			value: committeeSurvey.intervieweeJob,
		},
		{
			label: '被询问人电话',
			value: committeeSurvey.intervieweePhone,
		},
		{
			label: '实际居住地区',
			value: committeeSurvey.areaDesc,
		},
		{
			label: '详细地址',
			value: committeeSurvey.address,
		},
		{
			label: '所住房屋户主姓名',
			value: committeeSurvey.houseOwnerName,
		},
		{
			label: '所住房屋户主电话',
			value: committeeSurvey.houseOwnerPhone,
		},
		{
			label: '是否签字',
			value: setting.yesNoMap[committeeSurvey.sign],
		},
		{
			label: '备注（非必填）',
			value: committeeSurvey.remark,
		},
	]
	return {
		title: '居委会/村委会/街道办走访记录',
		children: arr,
	}
}
